import { UpsellStep } from "@redotech/redo-flows-common/steps";
import { useTranslation } from "@redotech/redo-i18n";
import UpRightIcon from "@redotech/redo-icons/arrow-narrow-up-right_filled.svg";
import { RedoFeaturedIcon } from "@redotech/redo-web/arbiter-components/featured-icon/redo-featured-icon";
import { Handle, Position } from "@xyflow/react";
import { PartialWithRequiredType } from "../steps";
import { BaseNode } from "./base-node";

export interface UpsellNodeData {
  step: PartialWithRequiredType<UpsellStep>;
  deleteElements: (id: string) => void;
}

export function UpsellNode(data: {
  id: string;
  data: UpsellNodeData;
  selected?: boolean | undefined;
}) {
  const { t } = useTranslation();

  return (
    <>
      <Handle position={Position.Top} type="target" />
      <BaseNode
        icon={<RedoFeaturedIcon color="success" Icon={UpRightIcon} size="xs" />}
        onDelete={() => data.data.deleteElements(data.id)}
        selected={data.selected}
        step={data.data.step}
        title={data.data.step.name ?? t("Upsell")}
      />
      <Handle position={Position.Bottom} type="source" />
    </>
  );
}
